/**
 * Code Generator Utility
 *
 * Shared utility for generating secure random codes (OTP, link codes, etc.)
 * v11.11.2
 */

/**
 * Generate a random numeric code of specified length
 * @param {number} length - Length of code (default 6)
 * @returns {string} - Random numeric code
 */
export function generateNumericCode(length = 6) {
  const min = Math.pow(10, length - 1);
  const max = Math.pow(10, length) - 1;
  return Math.floor(min + Math.random() * (max - min + 1)).toString();
}

/**
 * Generate a 6-digit OTP code
 * @returns {string} - 6-digit OTP
 */
export function generateOTP() {
  return generateNumericCode(6);
}

/**
 * Generate a 6-digit link code for parent-child linking
 * @returns {string} - 6-digit link code
 */
export function generateLinkCode() {
  return generateNumericCode(6);
}

/**
 * Generate a more secure alphanumeric code
 * @param {number} length - Length of code (default 8)
 * @returns {string} - Alphanumeric code
 */
export function generateAlphanumericCode(length = 8) {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // Exclude similar chars: I, O, 0, 1
  let code = '';
  for (let i = 0; i < length; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

/**
 * Validate numeric code format
 * @param {string} code - Code to validate
 * @param {number} length - Expected length
 * @returns {boolean} - True if valid
 */
export function validateNumericCode(code, length = 6) {
  if (!code || typeof code !== 'string') return false;
  if (code.length !== length) return false;
  return /^\d+$/.test(code);
}

export default {
  generateNumericCode,
  generateOTP,
  generateLinkCode,
  generateAlphanumericCode,
  validateNumericCode
};
